var map = {
	"./auth/auth.module.ngfactory": [
		"./src/app/auth/auth.module.ngfactory.js",
		"common",
		"auth-auth-module-ngfactory"
	],
	"./banner/banner.module.ngfactory": [
		"./src/app/pages/banner/banner.module.ngfactory.js",
		"default~banner-banner-module-ngfactory~boardingpage-boardingpage-module-ngfactory~splashscreen-splas~ddbd4058",
		"banner-banner-module-ngfactory"
	],
	"./boardingpage/boardingpage.module.ngfactory": [
		"./src/app/pages/boardingpage/boardingpage.module.ngfactory.js",
		"default~banner-banner-module-ngfactory~boardingpage-boardingpage-module-ngfactory~splashscreen-splas~ddbd4058",
		"boardingpage-boardingpage-module-ngfactory"
	],
	"./broadcast/broadcast.module.ngfactory": [
		"./src/app/pages/broadcast/broadcast.module.ngfactory.js",
		"default~broadcast-broadcast-module-ngfactory~terms-terms-module-ngfactory",
		"broadcast-broadcast-module-ngfactory"
	],
	"./group/group.module.ngfactory": [
		"./src/app/pages/group/group.module.ngfactory.js",
		"default~group-group-module-ngfactory~sweetalert2",
		"default~group-group-module-ngfactory~region-region-module-ngfactory",
		"group-group-module-ngfactory"
	],
	"./home/home.module.ngfactory": [
		"./src/app/pages/home/home.module.ngfactory.js",
		"home-home-module-ngfactory"
	],
	"./manage-information/manage-information.module.ngfactory": [
		"./src/app/pages/manage-information/manage-information.module.ngfactory.js",
		"manage-information-manage-information-module-ngfactory"
	],
	"./member/member.module.ngfactory": [
		"./src/app/pages/member/member.module.ngfactory.js",
		"member-member-module-ngfactory"
	],
	"./pages/pages.module.ngfactory": [
		"./src/app/pages/pages.module.ngfactory.js",
		"pages-pages-module-ngfactory"
	],
	"./quote/quote.module.ngfactory": [
		"./src/app/pages/quote/quote.module.ngfactory.js",
		"quote-quote-module-ngfactory"
	],
	"./quran/quran.module.ngfactory": [
		"./src/app/pages/quran/quran.module.ngfactory.js",
		"quran-quran-module-ngfactory"
	],
	"./region/region.module.ngfactory": [
		"./src/app/pages/region/region.module.ngfactory.js",
		"default~group-group-module-ngfactory~region-region-module-ngfactory",
		"region-region-module-ngfactory"
	],
	"./splashscreen/splashscreen.module.ngfactory": [
		"./src/app/pages/splashscreen/splashscreen.module.ngfactory.js",
		"default~banner-banner-module-ngfactory~boardingpage-boardingpage-module-ngfactory~splashscreen-splas~ddbd4058",
		"splashscreen-splashscreen-module-ngfactory"
	],
	"./terms/terms.module.ngfactory": [
		"./src/app/pages/terms/terms.module.ngfactory.js",
		"default~broadcast-broadcast-module-ngfactory~terms-terms-module-ngfactory",
		"terms-terms-module-ngfactory"
	],
	"./tutorial-apps/tutorial-apps.module.ngfactory": [
		"./src/app/pages/tutorial-apps/tutorial-apps.module.ngfactory.js",
		"tutorial-apps-tutorial-apps-module-ngfactory"
	],
	"./user/user.module.ngfactory": [
		"./src/app/pages/user/user.module.ngfactory.js",
		"common",
		"user-user-module-ngfactory"
	],
	"./version-apps/version-apps.module.ngfactory": [
		"./src/app/pages/version-apps/version-apps.module.ngfactory.js",
		"version-apps-version-apps-module-ngfactory"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;